import React from 'react'

export const Divider = props => {
  return (
    <div
      style={{
        margin: '20px 0px',
        width: '100%',
        background: props.color || 'grey',
        height: '1px'
      }}
      className='d3-divider'
    />
  )
}

export default Divider



// WEBPACK FOOTER //
// ./src/components/Divider.js